import { twMerge } from 'tailwind-merge';

const DEFAULT_INLINE_LABEL_WIDTH =
  'min-w-[10rem] sm:min-w-[16rem] md:min-w-[18rem] max-w-[18rem]';

type FormItemLayoutOptions = {
  inline: boolean;
  compactInline: boolean;
  labelContainerClassName?: string;
};

export type FormItemLayoutClasses = {
  root: string;
  labelContainer: string;
  inputWrapper: string;
  inputInner: string;
  reserveInlineErrorSpace: boolean;
};

function getInlineLabelContainerClass(
  isCompactInline: boolean,
  labelContainerClassName?: string
): string {
  const sizeClass = isCompactInline ? 'shrink-0 min-h-0' : 'min-h-[4rem]';
  const widthClass = isCompactInline ? undefined : DEFAULT_INLINE_LABEL_WIDTH;

  return twMerge(
    'font-normal text-secondary',
    sizeClass,
    labelContainerClassName || widthClass
  );
}

export function getFormItemLayoutClasses({
  inline,
  compactInline,
  labelContainerClassName,
}: FormItemLayoutOptions): FormItemLayoutClasses {
  const isCompactInline = inline && compactInline;

  if (!inline) {
    return {
      root: 'flex-col gap-y-2 w-full',
      labelContainer: twMerge(
        'font-medium text-mainText',
        labelContainerClassName
      ),
      inputWrapper: 'w-full',
      inputInner: 'w-full',
      reserveInlineErrorSpace: false,
    };
  }

  if (isCompactInline) {
    return {
      root: 'flex-row flex-nowrap gap-x-2 items-center w-full',
      labelContainer: getInlineLabelContainerClass(true, labelContainerClassName),
      inputWrapper: 'flex-1 min-w-0 w-full',
      inputInner: 'flex items-center justify-start min-h-0 w-full',
      reserveInlineErrorSpace: false,
    };
  }

  return {
    root: 'flex-row flex-wrap gap-x-4 items-start',
    labelContainer: getInlineLabelContainerClass(false, labelContainerClassName),
    inputWrapper: 'sm:flex-1 min-w-0',
    inputInner: 'flex items-center justify-start min-h-[4rem]',
    reserveInlineErrorSpace: true,
  };
}
